<template>
  <div class="pt-[31px]">
    <div class="mb-[15px] flex justify-center">
      <img :src="svg1" alt="replacement kit" />
    </div>
    <div
      class="mb-3 text-[15px] font-semibold uppercase leading-6 text-gpx_black-400"
    >
      You will need
    </div>
    <div class="px-6">
      <ul
        class="list-disc text-[15px] leading-6 text-gpx_black-400 marker:text-[32px] marker:text-gpx_slate-900"
      >
        <li>
          <span class="relative bottom-[5px]">Your Mobile 200 tracker</span>
        </li>
        <li>
          <span class="relative bottom-[5px]">
            Your SIM replacement kit included a device specific screwdriver.
            Another one might not work.
          </span>
        </li>
        <li>
          <span class="relative bottom-[5px]"
            >Your new SIM card we sent to you</span
          >
        </li>
      </ul>
    </div>
  </div>
  <div class="flex justify-between gap-x-4 pb-[18px] pt-[24px]">
    <Button
      variant="tertiary"
      size="lg"
      class="w-[124px]"
      @click="$emit('onCancel')"
    >
      Back
    </Button>
    <Button @click="$emit('onConfirm')" class="w-full">
      Continue
    </Button>
  </div>
</template>

<script>
import Step1Svg1 from './assets/step-1.svg';

export default {
  emits: ['onConfirm', 'onCancel'],
  computed: {
    svg1() {
      return Step1Svg1;
    },
  },
};
</script>
